import { BaseModel } from './base-model';

export class SessionModel implements BaseModel {
  public apiVersion: number;
  public magichomeVersion: string;
  public cloudId: string;
  public refreshToken: string;
  public sessionId: string;
  public username: string;

  init() {}
}
